import { useCallback, useEffect, useState } from "react";
import Loader from "../../../components/Loader";
import { Modal, Button, Col, Container, Row } from "react-bootstrap";
import Swal from "sweetalert2";
import ImgRotate from "../../../components/ImgRotate";
import { confirm, error, success } from "../../../components/SwalAlertData";
import identificationsTypeServices from "../../../services/parametricServices";
import {
  deletePersonUser,
  getAdminStatus,
  getPersonById,
  setAdminStatusToPerson,
  updatePerson,
} from "../../../services/personServices";
import {
  downloadIdentificationImagesService,
  getImageService,
} from "../../../services/registerServices";
import { variantsGender } from "../../../components/ComponentsData";
import useAuth from "../../../hooks/useAuth";
import { getInstitutionsAllWithNewData } from "../../../services/institutionsServices";

export default function EnablePatient({
  show,
  handleClose,
  id,
  action,
  status_name,
}) {
  const [loading, setLoading] = useState(true);
  const auth = useAuth();
  const [patient, setPatient] = useState(null);
  const [idnType, setIdnType] = useState(1);
  const [genderType, setGenderType] = useState(null);
  const [birthdate, setBirthdate] = useState(null);
  const [adminStatus, setAdminStatus] = useState([]);
  const [institutions, setInstitutions] = useState([]);
  const [imgFront, setImgFront] = useState("");
  const [imgBack, setImgBack] = useState("");

  const getPatient = useCallback(
    (id) => {
      getPersonById(id)
        .then((res) => {
          if (res.id) {
            setPatient(res);
          } else {
            Swal.fire(error("Error al cargar datos de paciente"));
            handleClose();
          }
        })
        .catch((err) => {
          console.log("error", err);
          Swal.fire(error(err));
          handleClose();
        });
    },
    [handleClose]
  );

  const getBirthdate = (birthdate) => {
    let date = new Date(birthdate).toLocaleDateString();
    setBirthdate(date);
  };

  const getDNIVariants = useCallback((idType) => {
    identificationsTypeServices()
      .then((res) => {
        if (res?.length > 0) {
          const type = res.find((t) => t.id === idType);
          setIdnType(type);
        }
      })
      .catch((err) => {
        console.log("error", err);
        Swal.fire(error(err));
        handleClose();
      });
  }, [handleClose]);
  
  const getGender = (id_gender) => {
    let gender = variantsGender.find((g) => g.id === id_gender);
    setGenderType(gender);
  };

  const getImage = useCallback((imgName, is_front) => {
    getImageService(imgName, auth.tokenUser)
      .then((res) => {
        if (res && is_front) {
          setImgFront(res);
        } else if (res && !is_front) {
          setImgBack(res);
          setLoading(false);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, [auth.tokenUser]);
  
  const downloadImage = useCallback((id, is_front) => {
    downloadIdentificationImagesService(id, is_front)
      .then((res) => {
        if (res.ok) {
          return res.text().then((text) => {
            let readeble = JSON.parse(text);
            if (readeble.status) {
              if (is_front) {
                getImage(readeble.value, is_front);
                downloadImage(id, false);
              } else {
                getImage(readeble.value, is_front);
              }
            } else {
              throw new Error(text);
            }
          });
        } else {
          console.log("error", res);
          throw new Error(res);
        }
      })
      .catch((err) => {
        console.log("error", err);
        setLoading(false);
      });
  }, [getImage]);

  const getAdminStatusToSetPerson = useCallback(() => {
    getAdminStatus()
      .then((res) => {
        setAdminStatus(res);
      })
      .catch((err) => {
        console.log("Error", err);
        Swal.fire(error("Error al obtenter estados"));
        handleClose();
      });
  }, [handleClose]);

  const getInstitutions = useCallback(() => {
    getInstitutionsAllWithNewData()
      .then((res) => {
        const allInstitutions = res;
        setInstitutions(allInstitutions);
        return allInstitutions;
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    if (show) {
      getPatient(id);
    }
  }, [show, id, getPatient]);

  useEffect(() => {
    if (show && patient) {
      getAdminStatusToSetPerson();
      getInstitutions();
      getDNIVariants(patient.id_identification_type);
      getBirthdate(patient.birthdate);
      getGender(patient.id_gender);
      downloadImage(patient.id, true);
    }
  }, [show, patient, getDNIVariants, getAdminStatusToSetPerson, getInstitutions, downloadImage]);

  const changeAdminStatusToPerson = useCallback((id, status) => {
    setAdminStatusToPerson(id, status.id) //note  1: pending , 2: validated , 3: refused api_endpoint /getadminstatus
      .then((res) => {
        if (res.ok) {
          return res.text().then((text) => {
            let readeble = JSON.parse(text);
            if (readeble.status) {
              Swal.fire(success(`Estado ${status.name}`));
              action();
              handleClose();
            } else {
              Swal.fire(error("Hubo un error al intentar cambiar el estado"));
              throw new Error(text);
            }
          });
        }
      })
      .catch((err) => {
        console.log("error", err);
        Swal.fire(error("Hubo un error al intentar cambiar el estado"));
        handleClose();
      });
  }, [action, handleClose]);

  const deleteUser = useCallback((patient) => {
    const body = { username: patient.email };
    deletePersonUser(body)
      .then((res) => {
        if (res.ok) {
          Swal.fire(success("Usuario eliminado"));
          action();
          handleClose();
        } else {
          Swal.fire(error("Hubo un error al intentar eliminar usuario"));
          throw new Error(res);
        }
      })
      .catch((err) => {
        console.error("error", err);
        Swal.fire(error("Hubo un error al intentar eliminar usuario"));
        handleClose();
      });
  }, [action, handleClose]);

  const handleValidate = (id) => {
    Swal.fire(confirm("¿Validar solicitud?")).then((result) => {
      if (result.isConfirmed) {
        let status = adminStatus.find((s) => s.name === "VALIDADO");
        changeAdminStatusToPerson(id, status);
      }
    });
  };

  const handleReject = (id) => {
    Swal.fire(confirm("¿Rechazar solicitud?")).then((result) => {
      if (result.isConfirmed) {
        let status = adminStatus.find((s) => s.name === "RECHAZADO");
        changeAdminStatusToPerson(id, status);
      }
    });
  };

  const handleSendToPending = (id) => {
    Swal.fire(confirm("¿Enviar usuario a listado de pendientes?")).then(
      (result) => {
        if (result.isConfirmed) {
          let status = adminStatus.find(
            (s) => s.name === "PENDIENTE DE VALIDACIÓN"
          );
          changeAdminStatusToPerson(id, status);
        }
      }
    );
  };

  const handleDelete = (patient) => {
    Swal.fire(confirm("¿Eliminar usuario definitivamente?")).then((result) => {
      if (result.isConfirmed) {
        deleteUser(patient);
      }
    });
  };

  const formatBirthdate = (birthdate) => {
    if (!birthdate) return birthdate;
    try {
      const date = new Date(birthdate);
      const day = date.getDate().toString().padStart(2, '0');
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    } catch (error) {
      console.error('Error al formatear fecha:', error);
      return birthdate;
    }
  };

  const setValidateMail = useCallback((patient) => {
    const body = { 
        ...patient,
        id_person_status: 2,
        birthdate: formatBirthdate(patient.birthdate)
    };
    updatePerson(body)
      .then((res) => {
        if (res.ok) {
          action();
        } else {
          Swal.fire(error("Hubo un error al intentar validar el email"));
          throw new Error(res);
        }
      })
      .catch((err) => {
        console.error("**** error", err);
        Swal.fire(error("Hubo un error al intentar validar el email"));
        handleClose();
      });
  }, [action, handleClose]);  

  const handleValidateMail = (patient) => {
    Swal.fire(confirm("¿Va a validar este mail?")).then((result) => {
      if (result.isConfirmed) {
        setValidateMail(patient);
      }
    });
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
      size="lg"
      fullscreen={true}
      className="admin-patient__modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>Solicitud de alta de paciente</Modal.Title>
      </Modal.Header>
      {loading ? (
        <Loader isActive={loading}></Loader>
      ) : (
        <>
          <Modal.Body>
            <Container fluid>
              <Row>
                <Col xs={12} lg={6}>
                  <Row>
                    <Col xs={12} className="mb-3">
                      <h5>Datos de paciente </h5>
                      <ul className="fw-lighter admin-patient__list">
                        <li>
                          Nombre: <strong>{patient.name || " - "}</strong>
                        </li>
                        <li>
                          Apellido: <strong>{patient.surname || " - "}</strong>
                        </li>
                        <li>
                          Tipo de documento:{" "}
                          <strong>{idnType?.description || " - "}</strong>
                        </li>
                        <li>
                          Número de documento:{" "}
                          <strong>
                            {patient.identification_number || " - "}
                          </strong>
                        </li>
                        <li>
                          Fecha de nacimiento:{" "}
                          <strong>{birthdate || " - "}</strong>
                        </li>
                        <li>
                          Sexo: <strong>{genderType?.name || " - "}</strong>
                        </li>
                      </ul>
                    </Col>
                    <Col xs={12} className="mb-3">
                      <h5>Datos de contacto </h5>
                      <ul className="admin-patient__list">
                        <li>
                          Domicilio:{" "}
                          <strong>
                            {patient.address_street || " - "}{" "}
                            {patient.address_number || " - "} ,{" "}
                            {patient.department || " - "} ,{" "}
                            {patient.locality || " - "}{" "}
                          </strong>
                        </li>
                        <li>
                          <div className="mb-2">
                            <strong>Email:</strong>
                          </div>
                          <div className="d-flex flex-column gap-1">
                            <div
                              className={`border border-${
                                patient.id_person_status === 1
                                  ? "danger"
                                  : "success"
                              } rounded p-2`}
                            >
                              {patient.email || " - "}
                            </div>
                            <div className="d-flex align-items-center justify-content-between">
                              <span
                                className={`badge ${
                                  patient.id_person_status === 1
                                    ? "bg-danger"
                                    : "bg-success"
                                }`}
                              >
                                {patient.id_person_status === 1
                                  ? "AÚN NO VALIDADO 🗙"
                                  : "VALIDADO ✓"}
                              </span>
                              {patient.id_person_status === 1 && (
                                <Button
                                  variant="primary"
                                  onClick={() => handleValidateMail(patient)}
                                >
                                  Validar este mail
                                </Button>
                              )}
                            </div>
                          </div>
                        </li>
                        <li>
                          Teléfono:{" "}
                          <strong>{patient.phone_number || " - "}</strong>
                        </li>
                      </ul>
                    </Col>
                    <Col xs={12} className="mb-3">
                      <h5>Grupo familiar </h5>
                      <ul className="admin-patient__list">
                        <li>
                          ID grupo familiar:{" "}
                          <strong>
                            {patient.identification_number_master || " - "}
                          </strong>{" "}
                        </li>
                      </ul>
                    </Col>
                    <Col xs={12} className="mb-3">
                      <h5>Establecimiento de atencion usual</h5>
                      <ul className="admin-patient__list">
                        <li>
                          {institutions.find(
                            (item) => item.id === patient.id_usual_institution
                          )?.name || " - "}
                        </li>
                      </ul>
                    </Col>
                  </Row>
                </Col>
                <Col xs={12} lg={6}>
                  <h5>Imágenes de documento </h5>
                  <ImgRotate img={imgFront}></ImgRotate>
                  <ImgRotate img={imgBack}></ImgRotate>
                </Col>
              </Row>
            </Container>
          </Modal.Body>
          <Modal.Footer className="p-3 d-flex justify-content-start">
            <Button variant="outline-secondary" onClick={handleClose}>
              Cancelar
            </Button>
            {status_name === "PENDIENTE DE VALIDACIÓN" && (
              <Button
                variant="outline-danger"
                onClick={() => handleReject(patient.id)}
              >
                Rechazar solicitud
              </Button>
            )}
            {status_name === "PENDIENTE DE VALIDACIÓN" && (
              <Button
                variant="primary"
                onClick={() => handleValidate(patient.id)}
                disabled={patient.id_person_status === 1}
              >
                Validar solicitud
              </Button>
            )}
            {status_name === "RECHAZADO" && (
              <Button
                variant="outline-danger"
                onClick={() => handleDelete(patient)}
              >
                Eliminar usuario
              </Button>
            )}
            {status_name === "RECHAZADO" && (
              <Button
                variant="primary"
                onClick={() => handleSendToPending(patient.id)}
              >
                Restaurar solicitud
              </Button>
            )}
          </Modal.Footer>
        </>
      )}
    </Modal>
  );
}
